import { PageTable } from '@components-common/layouts';
import { layoutCourse } from '../_common/layout.course';
import { layoutWorkspace } from '../../_website/_common/layout.workspace';
import { AddUserToCourse } from './dashboard-courses/AddUserToCourseModal';
import { deleteTableRow } from '../../components-common/_shared/actionButton.helper';

/**
 * Configuration Object: memberEntityConfig
 *
 * This object contains the configuration for the member entity.
 * It includes columns, data source, layout, template, default values, endpoints, and schema.
 */
export const memberEntityConfig = {
  columns: [
    { id: 'name', dataField: 'user.displayName' },
    { id: 'email', dataField: 'user.email' },
    'role',
    'state',
  ],
  source: `/coursesms/members/all`,
  layout: layoutCourse,
  template: '/courses/:courseId/students',
  empty: {
    id: '',
    name: '',
    email: '',
    state: 'ACTIVE',
    modifiedDate: new Date(Date.now()),
    createdDate: new Date(Date.now()),
  },
  endpoints: `/coursesms/members`,
  schema: {},
};

/**
 * Configuration Array: courseMembersScreens
 *
 * This array contains the configuration for the course members screens.
 * It includes roles, layout, URL parameters, columns, and actions.
 */
export const courseMembersScreens: any = [
  {
    id: 'people',
    path: 'people',
    layout: layoutWorkspace,
    protected: false,
    roles: ['STUDY_DIRECTOR', 'LECTURER'],
    urlParams: {
      courseId: '{id}',
    },
    left: [
      {
        kind: 'open_modal',
        label: 'Add users',
        actionToDispatch: {
          action: 'open_modal',
          payload: {
            Component: AddUserToCourse,
            show: true,
            size: 'lg',
          },
        },
      },
    ],
    Component: PageTable,
    source: memberEntityConfig.source,
    tmp: 'index',
    columns: memberEntityConfig.columns,
    actions: [
      {
        id: 'delete',
        roles: ['STUDY_DIRECTOR', 'LECTURER'],
        actionToDispatch: {
          payload: {
            endpointToDelete: `/coursesms/members`,
          },
        },
        displayTooltip: true,
        tooltipText: 'Delete user',
      },
    ],
  },
];
